import React from "react";

const SuspendedPage = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center',
      padding: '20px',
      backgroundColor: '#f5f5f5'
    }}>
      <h3 style={{
        fontSize: '2rem',
        marginBottom: '1rem',
        color: '#333'
      }}>503 Service Temporarily Unavailable</h3>
      <p style={{
        fontSize: '1.1rem',
        color: '#666',
        maxWidth: '600px'
      }}>
        The server is temporarily unable to service your request due to maintenance downtime or capacity problems. Please try again later.
      </p>
    </div>
  );
};

export default SuspendedPage;
